export const mapCategoryToTranslationKey = category => {
  switch (category) {
    case 'all':
      return 'all';
    case 'new-to-you':
      return 'newToYou';
    case 'in-beta':
      return 'inBeta';
    case 'in-development':
      return 'inDevelopment';
    case 'live':
      return 'live';
    case 'scheduled-for-release':
      return 'scheduledForRelease';
    case 'sunset':
      return 'sunset';
    case 'recommended':
      return 'recommended';
    case 'your-betas':
      return 'yourBetas';
    default:
      return undefined;
  }
};